export default __webpack_public_path__ + "4a4fa0b6c7622dce0ee5de67e6597bc5.png";